import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectTransactionStore = (state: CommonState) =>
  state.transactions || state.straitsXTransactions

export const selectLatestTransactions = createSelector([selectTransactionStore], state => {
  return state.latestPersonalTransactions || state.latestTransactions
})

export const selectIsTrxInfoFetched = createSelector(
  [selectTransactionStore],
  state =>
    state.isUserHasFiatDeposit !== null &&
    state.isUserHasStablecoinDeposit !== null &&
    state.isUserHasStablecoinWithdrawal !== null &&
    state.isUserHasFiatWithdrawal !== null
)

export const selectIsUserHasFiatDeposit = createSelector(
  [selectTransactionStore],
  state => state.isUserHasFiatDeposit
)

export const selectIsUserHasStablecoinDeposit = createSelector(
  [selectTransactionStore],
  state => state.isUserHasStablecoinDeposit
)

export const selectIsUserHasFiatWithdrawal = createSelector(
  [selectTransactionStore],
  state => state.isUserHasFiatWithdrawal
)

export const selectIsUserHasStablecoinWithdrawal = createSelector(
  [selectTransactionStore],
  state => state.isUserHasStablecoinWithdrawal
)

export const selectTravelRuleComplianceBlockerTotalCount = createSelector(
  [selectTransactionStore],
  state => state.travelRuleComplianceBlockerTotalCount || 0
)

export const selectFundingTransactionTypeTab = createSelector(
  [selectTransactionStore],
  state => state.fundingTransactionTypeTab
)
